export default "__VITE_ASSET__bc9d7e0f__"